import {Route, Routes} from "react-router-dom";
import AdminDashboard from "../page/admin/dashboard";
import BlogDashboard from "../page/admin/blog";
import UsersDashboard from "../page/admin/user";
import UserDetail from "../page/admin/user/detail";
import BlogDetail from "../page/admin/blog/detail";
import LessonDashboard from "../page/admin/lesson";
import TopicDashboard from "../page/admin/topic";
import TopicDetail from "../page/admin/topic/detail";
import LessonDetail from "../page/admin/lesson/detail";
import TransferDetail from "../page/admin/transfer";
import CourseDashboard from "../page/admin/course";
import CourseDetail from "../page/admin/course/detail";
import ContactDashboard from "../page/admin/contact";
import PricingDashboard from "../page/admin/pricing";
import PricingDetail from "../page/admin/pricing/detail";
import PlaylistDashboard from "../page/admin/playlist";
import FloatButtonsAdmin from "../page/admin/floatbuttons";
import ImportPage from "../page/admin/import";

export const Admin = () => {
    return (
        <Routes>
            <Route path="/admin" element={<AdminDashboard/>}/>
            <Route path="/admin/dashboard" element={<AdminDashboard/>}/>
            <Route path="/admin/blog" element={<BlogDashboard/>}/>
            <Route path="/admin/blog/:slug" element={<BlogDetail/>}/>
            <Route path="/admin/lesson" element={<LessonDashboard/>}/>
            <Route path="/admin/lesson/:slug" element={<LessonDetail/>}/>
            <Route path="/admin/topic" element={<TopicDashboard/>}/>
            <Route path="/admin/topic/:slug" element={<TopicDetail/>}/>
            <Route path="/admin/course" element={<CourseDashboard/>}/>
            <Route path="/admin/course/:slug" element={<CourseDetail/>}/>
            <Route path="/admin/transfer" element={<TransferDetail/>}/>
            <Route path="/admin/user" element={<UsersDashboard/>}/>
            <Route path="/admin/users/create" element={<UserDetail/>}/>
            <Route path="/admin/users/:id" element={<UserDetail/>}/>
            <Route path="/admin/contact" element={<ContactDashboard/>}/>
            <Route path="/admin/pricing" element={<PricingDashboard/>}/>
            <Route path="/admin/pricing/:slug" element={<PricingDetail/>}/>
            <Route path="/admin/playlist" element={<PlaylistDashboard/>}/>
            <Route path="/admin/floatbuttons" element={<FloatButtonsAdmin/>}/>
            <Route path="/admin/import" element={<ImportPage/>}/>
        </Routes>
    );
};
